import { createReducer, on } from '@ngrx/store';
import * as FinanceManagementActions from './finance-management.actions';
import {
  handleRequest,
  handleSuccess,
  handleFailure,
  handleClear,
} from '../../../../shared/ngrx-factory/factory.reducer';

const initialRequestState: FinanceManagementActions.RequestState<any> = {
  loading: false,
  message: null,
  response: null,
  error: null,
};

export const initialState: FinanceManagementActions.FinanceManagementState = {
  companyBills: { ...initialRequestState },
  companyBillByUuid: { ...initialRequestState },
  bankGuaranteeByUuid: { ...initialRequestState },
  cashGuaranteeByUuid: { ...initialRequestState },
  bankConfigs: { ...initialRequestState },
  integratedBankGuaranteeSubmit: { ...initialRequestState },
  integratedBankGuaranteeList: { ...initialRequestState },
  manualBankGuaranteeSubmit: { ...initialRequestState },
  manualBankGuaranteeUpdate: { ...initialRequestState },
  manualBankGuaranteeList: { ...initialRequestState },
  cashGuaranteeSubmit: { ...initialRequestState },
  cashGuaranteeUpdate: { ...initialRequestState },
  cashGuaranteeList: { ...initialRequestState },
  manualBankGuaranteeStatusToggle: { ...initialRequestState },
  cashGuaranteeStatusToggle: { ...initialRequestState },
  submitFinancialSecurity: { ...initialRequestState },
  bankDetails: { ...initialRequestState },
  bankGuaranteeTypes: { ...initialRequestState },
  allBankGuaranteeSubmissions: { ...initialRequestState },
  omcGuaranteeSummary: { ...initialRequestState },
};

export const financeManagementReducer = createReducer(
  initialState,

  // 1. Company Bills
  on(FinanceManagementActions.CompanyBillsActions.request, (state) =>
    handleRequest(state, 'companyBills'),
  ),
  on(FinanceManagementActions.CompanyBillsActions.success, (state, { response }) =>
    handleSuccess(state, 'companyBills', response),
  ),
  on(FinanceManagementActions.CompanyBillsActions.failure, (state, { error }) =>
    handleFailure(state, 'companyBills', error),
  ),

  // 2. Company Bill By Uuid
  on(FinanceManagementActions.CompanyBillByUuidActions.request, (state) =>
    handleRequest(state, 'companyBillByUuid'),
  ),
  on(FinanceManagementActions.CompanyBillByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'companyBillByUuid', response),
  ),
  on(FinanceManagementActions.CompanyBillByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'companyBillByUuid', error),
  ),

  // 2b. Bank Guarantee By Uuid
  on(FinanceManagementActions.BankGuaranteeByUuidActions.request, (state) =>
    handleRequest(state, 'bankGuaranteeByUuid'),
  ),
  on(FinanceManagementActions.BankGuaranteeByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'bankGuaranteeByUuid', response),
  ),
  on(FinanceManagementActions.BankGuaranteeByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'bankGuaranteeByUuid', error),
  ),

  // 2c. Cash Guarantee By Uuid
  on(FinanceManagementActions.CashGuaranteeByUuidActions.request, (state) =>
    handleRequest(state, 'cashGuaranteeByUuid'),
  ),
  on(FinanceManagementActions.CashGuaranteeByUuidActions.success, (state, { response }) =>
    handleSuccess(state, 'cashGuaranteeByUuid', response),
  ),
  on(FinanceManagementActions.CashGuaranteeByUuidActions.failure, (state, { error }) =>
    handleFailure(state, 'cashGuaranteeByUuid', error),
  ),

  // 3. Integrated Bank Guarantee Submit
  on(FinanceManagementActions.IntegratedBankGuaranteeActions.request, (state) =>
    handleRequest(state, 'integratedBankGuaranteeSubmit'),
  ),
  on(FinanceManagementActions.IntegratedBankGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'integratedBankGuaranteeSubmit', response),
  ),
  on(FinanceManagementActions.IntegratedBankGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'integratedBankGuaranteeSubmit', error),
  ),
  on(FinanceManagementActions.IntegratedBankGuaranteeActions.clearState, (state) =>
    handleClear(state, 'integratedBankGuaranteeSubmit'),
  ),

  // 4. Manual Bank Guarantee Submit
  on(FinanceManagementActions.ManualBankGuaranteeActions.request, (state) =>
    handleRequest(state, 'manualBankGuaranteeSubmit'),
  ),
  on(FinanceManagementActions.ManualBankGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'manualBankGuaranteeSubmit', response),
  ),
  on(FinanceManagementActions.ManualBankGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'manualBankGuaranteeSubmit', error),
  ),
  on(FinanceManagementActions.ManualBankGuaranteeActions.clearState, (state) =>
    handleClear(state, 'manualBankGuaranteeSubmit'),
  ),

  on(FinanceManagementActions.UpdateManualBankGuaranteeActions.request, (state) =>
    handleRequest(state, 'manualBankGuaranteeUpdate'),
  ),
  on(FinanceManagementActions.UpdateManualBankGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'manualBankGuaranteeUpdate', response),
  ),
  on(FinanceManagementActions.UpdateManualBankGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'manualBankGuaranteeUpdate', error),
  ),
  on(FinanceManagementActions.UpdateManualBankGuaranteeActions.clearState, (state) =>
    handleClear(state, 'manualBankGuaranteeUpdate'),
  ),

  // 5. Cash Guarantee Submit
  on(FinanceManagementActions.CashGuaranteeActions.request, (state) =>
    handleRequest(state, 'cashGuaranteeSubmit'),
  ),
  on(FinanceManagementActions.CashGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'cashGuaranteeSubmit', response),
  ),
  on(FinanceManagementActions.CashGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'cashGuaranteeSubmit', error),
  ),
  on(FinanceManagementActions.CashGuaranteeActions.clearState, (state) =>
    handleClear(state, 'cashGuaranteeSubmit'),
  ),

  on(FinanceManagementActions.UpdateCashGuaranteeActions.request, (state) =>
    handleRequest(state, 'cashGuaranteeUpdate'),
  ),
  on(FinanceManagementActions.UpdateCashGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'cashGuaranteeUpdate', response),
  ),
  on(FinanceManagementActions.UpdateCashGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'cashGuaranteeUpdate', error),
  ),
  on(FinanceManagementActions.UpdateCashGuaranteeActions.clearState, (state) =>
    handleClear(state, 'cashGuaranteeUpdate'),
  ),

  // 6. Bank Configs
  on(FinanceManagementActions.BankConfigsActions.request, (state) =>
    handleRequest(state, 'bankConfigs'),
  ),
  on(FinanceManagementActions.BankConfigsActions.success, (state, { response }) =>
    handleSuccess(state, 'bankConfigs', response),
  ),
  on(FinanceManagementActions.BankConfigsActions.failure, (state, { error }) =>
    handleFailure(state, 'bankConfigs', error),
  ),

  // 7. List Integrated Bank Guarantee
  on(FinanceManagementActions.ListIntegratedBankGuaranteeActions.request, (state) =>
    handleRequest(state, 'integratedBankGuaranteeList'),
  ),
  on(FinanceManagementActions.ListIntegratedBankGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'integratedBankGuaranteeList', response),
  ),
  on(FinanceManagementActions.ListIntegratedBankGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'integratedBankGuaranteeList', error),
  ),

  // 8. List Manual Bank Guarantee
  on(FinanceManagementActions.ListManualBankGuaranteeActions.request, (state) =>
    handleRequest(state, 'manualBankGuaranteeList'),
  ),
  on(FinanceManagementActions.ListManualBankGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'manualBankGuaranteeList', response),
  ),
  on(FinanceManagementActions.ListManualBankGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'manualBankGuaranteeList', error),
  ),

  // 9. List Cash Guarantee
  on(FinanceManagementActions.ListCashGuaranteeActions.request, (state) =>
    handleRequest(state, 'cashGuaranteeList'),
  ),
  on(FinanceManagementActions.ListCashGuaranteeActions.success, (state, { response }) =>
    handleSuccess(state, 'cashGuaranteeList', response),
  ),
  on(FinanceManagementActions.ListCashGuaranteeActions.failure, (state, { error }) =>
    handleFailure(state, 'cashGuaranteeList', error),
  ),

  // 9b. List All Bank Guarantee Submissions
  on(FinanceManagementActions.ListAllBankGuaranteeSubmissionsActions.request, (state) =>
    handleRequest(state, 'allBankGuaranteeSubmissions'),
  ),
  on(FinanceManagementActions.ListAllBankGuaranteeSubmissionsActions.success, (state, { response }) =>
    handleSuccess(state, 'allBankGuaranteeSubmissions', response),
  ),
  on(FinanceManagementActions.ListAllBankGuaranteeSubmissionsActions.failure, (state, { error }) =>
    handleFailure(state, 'allBankGuaranteeSubmissions', error),
  ),

  // 9c. Bank Details
  on(FinanceManagementActions.BankDetailsActions.request, (state) =>
    handleRequest(state, 'bankDetails'),
  ),
  on(FinanceManagementActions.BankDetailsActions.success, (state, { response }) =>
    handleSuccess(state, 'bankDetails', response),
  ),
  on(FinanceManagementActions.BankDetailsActions.failure, (state, { error }) =>
    handleFailure(state, 'bankDetails', error),
  ),
  on(FinanceManagementActions.BankDetailsActions.clearState, (state) =>
    handleClear(state, 'bankDetails'),
  ),

  // 9d. Bank Guarantee Types
  on(FinanceManagementActions.BankGuaranteeTypesActions.request, (state) =>
    handleRequest(state, 'bankGuaranteeTypes'),
  ),
  on(FinanceManagementActions.BankGuaranteeTypesActions.success, (state, { response }) =>
    handleSuccess(state, 'bankGuaranteeTypes', response),
  ),
  on(FinanceManagementActions.BankGuaranteeTypesActions.failure, (state, { error }) =>
    handleFailure(state, 'bankGuaranteeTypes', error),
  ),
  on(FinanceManagementActions.BankGuaranteeTypesActions.clearState, (state) =>
    handleClear(state, 'bankGuaranteeTypes'),
  ),

  // 10. Toggle Manual Bank Guarantee Status
  on(FinanceManagementActions.ToggleManualBankGuaranteeStatusActions.request, (state) =>
    handleRequest(state, 'manualBankGuaranteeStatusToggle'),
  ),
  on(FinanceManagementActions.ToggleManualBankGuaranteeStatusActions.success, (state, { response }) =>
    handleSuccess(state, 'manualBankGuaranteeStatusToggle', response),
  ),
  on(FinanceManagementActions.ToggleManualBankGuaranteeStatusActions.failure, (state, { error }) =>
    handleFailure(state, 'manualBankGuaranteeStatusToggle', error),
  ),
  on(FinanceManagementActions.ToggleManualBankGuaranteeStatusActions.clearState, (state) =>
    handleClear(state, 'manualBankGuaranteeStatusToggle'),
  ),

  // 11. Toggle Cash Guarantee Status
  on(FinanceManagementActions.ToggleCashGuaranteeStatusActions.request, (state) =>
    handleRequest(state, 'cashGuaranteeStatusToggle'),
  ),
  on(FinanceManagementActions.ToggleCashGuaranteeStatusActions.success, (state, { response }) =>
    handleSuccess(state, 'cashGuaranteeStatusToggle', response),
  ),
  on(FinanceManagementActions.ToggleCashGuaranteeStatusActions.failure, (state, { error }) =>
    handleFailure(state, 'cashGuaranteeStatusToggle', error),
  ),
  on(FinanceManagementActions.ToggleCashGuaranteeStatusActions.clearState, (state) =>
    handleClear(state, 'cashGuaranteeStatusToggle'),
  ),

  // 12. Submit Financial Security
  on(FinanceManagementActions.SubmitFinancialSecurityActions.request, (state) =>
    handleRequest(state, 'submitFinancialSecurity'),
  ),
  on(FinanceManagementActions.SubmitFinancialSecurityActions.success, (state, { response }) =>
    handleSuccess(state, 'submitFinancialSecurity', response),
  ),
  on(FinanceManagementActions.SubmitFinancialSecurityActions.failure, (state, { error }) =>
    handleFailure(state, 'submitFinancialSecurity', error),
  ),
  on(FinanceManagementActions.SubmitFinancialSecurityActions.clearState, (state) =>
    handleClear(state, 'submitFinancialSecurity'),
  ),

  // 13. OMC Guarantee Summary
  on(FinanceManagementActions.OmcGuaranteeSummaryActions.request, (state) =>
    handleRequest(state, 'omcGuaranteeSummary'),
  ),
  on(FinanceManagementActions.OmcGuaranteeSummaryActions.success, (state, { response }) =>
    handleSuccess(state, 'omcGuaranteeSummary', response),
  ),
  on(FinanceManagementActions.OmcGuaranteeSummaryActions.failure, (state, { error }) =>
    handleFailure(state, 'omcGuaranteeSummary', error),
  ),
  on(FinanceManagementActions.OmcGuaranteeSummaryActions.clearState, (state) =>
    handleClear(state, 'omcGuaranteeSummary'),
  ),
);
